import {
  Box,
  Button as MuiButton,
  Grid,
  Link,
  Stack,
  Typography,
} from "@mui/material";

import { PagePaper, SectionPaper } from "../../components/Paper";
import { PageTitle } from "../../components/Title";
import { FeedGrid } from "./components/FeedGrid";
import { KeyboardArrowLeft } from "@mui/icons-material";
import TopicIcon from "@mui/icons-material/Topic";
import React, { useState } from "react";
import { useFeatureFlags } from "@/configs/featureFlag";
import { ExecuteModal } from "@/features/monitoring/components/ExecuteModal";
import { type GridRowId } from "@mui/x-data-grid";

export const AcquireBookListPresenter: React.FC = () => {
  const { mypageTop, realEstateRegistrationMonitoring } = useFeatureFlags();

  const [
    openMonitoringExecuteConfirmDialog,
    setOpenMonitoringExecuteConfirmDialog,
  ] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<GridRowId>(""); // チェックボックスやAction選択の管理用State
  const [
    chargeCountClickedMonitoringExecuteButton,
    setChargeCountClickedMonitoringExecuteButton,
  ] = useState<number | null>(null);

  return (
    <PagePaper>
      <form>
        <Box sx={{ display: "flex" }}>
          {/* ページタイトル */}
          <Box sx={{ display: "flex", mb: 3 }}>
            <TopicIcon sx={{ mr: 1 }} fontSize="large" />
            <PageTitle>取得済不動産登記を検索する</PageTitle>
          </Box>
        </Box>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs>
            <Stack my={2} direction="row" justifyContent="end" spacing={1}>
              <MuiButton
                variant="contained"
                size="medium"
                component={Link}
                href={"/acquirebook"}
                sx={{ textAlign: "center", fontWeight: "bold" }}
              >
                地番・家屋番号から
                <br />
                不動産登記簿を取得する
              </MuiButton>
              <MuiButton
                variant="contained"
                component={Link}
                href={"/acquiremultiplebooks/upload"}
                sx={{ textAlign: "center", fontWeight: "bold" }}
              >
                地番・家屋番号リストから
                <br />
                不動産登記簿を取得する
              </MuiButton>
            </Stack>
          </Grid>
        </Grid>
        <SectionPaper>
          <FeedGrid
            setOpenMonitoringExecuteConfirmDialog={
              setOpenMonitoringExecuteConfirmDialog
            }
            setChargeCountClickedMonitoringExecuteButton={
              setChargeCountClickedMonitoringExecuteButton
            }
            setSelectedId={setSelectedId}
          />
          <Box sx={{ mb: 6 }} />
          <Stack
            direction={"row"}
            spacing={4}
            justifyContent={"center"}
            mb={2}
          ></Stack>
        </SectionPaper>

        {/* 戻る */}
        <Box sx={{ mt: 2 }}>
          <Link
            href={mypageTop ? "/mypage" : "/feed"}
            sx={{ display: "inline-block" }}
          >
            <Box sx={{ display: "flex" }}>
              <KeyboardArrowLeft />
              <Typography>
                {mypageTop ? "マイページに戻る" : "不動産の権利異動検索に戻る"}
              </Typography>
            </Box>
          </Link>
        </Box>
      </form>
      {realEstateRegistrationMonitoring &&
        chargeCountClickedMonitoringExecuteButton && (
          <ExecuteModal
            open={openMonitoringExecuteConfirmDialog}
            setOpen={setOpenMonitoringExecuteConfirmDialog}
            chargeCount={chargeCountClickedMonitoringExecuteButton}
            pictureRequestId={Number(selectedId)}
          />
        )}
    </PagePaper>
  );
};
